import { useRef } from "react";
import { SoundIcon } from "./Icons";
import { useDialogFocusTrap } from "./useDialogFocusTrap";

interface SettingsModalProps {
  muted: boolean;
  reducedMotion: boolean;
  highContrast: boolean;
  musicVolume: number;
  effectsVolume: number;
  onClose: () => void;
  onToggleMute: () => void;
  onToggleReducedMotion: () => void;
  onToggleHighContrast: () => void;
  onMusicVolume: (value: number) => void;
  onEffectsVolume: (value: number) => void;
}

function VolumeSlider(props: {
  label: string;
  value: number;
  onChange: (value: number) => void;
}) {
  const percent = Math.round(props.value * 100);
  return (
    <label className="settings-slider">
      <span>{props.label}</span>
      <input
        type="range"
        min={0}
        max={100}
        step={5}
        value={percent}
        onChange={(event) => props.onChange(Number(event.currentTarget.value) / 100)}
      />
      <b>{percent}%</b>
    </label>
  );
}

export function SettingsModal(props: SettingsModalProps) {
  const panelRef = useRef<HTMLElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);
  useDialogFocusTrap(panelRef, closeRef);
  return (
    <div className="modal-layer" role="dialog" aria-modal="true" aria-labelledby="settings-title">
      <section ref={panelRef} className="storybook-panel settings-panel">
        <h2 id="settings-title">הגדרות</h2>
        <button className="secondary-button" onClick={props.onToggleMute}><SoundIcon muted={props.muted} />{props.muted ? "הפעלת צלילים" : "השתקת צלילים"}</button>
        <VolumeSlider label="עוצמת מוזיקה" value={props.musicVolume} onChange={props.onMusicVolume} />
        <VolumeSlider label="עוצמת צלילים" value={props.effectsVolume} onChange={props.onEffectsVolume} />
        <button className={`secondary-button ${props.reducedMotion ? "active" : ""}`} onClick={props.onToggleReducedMotion}>הפחתת תנועה {props.reducedMotion ? "פעילה" : "כבויה"}</button>
        <button className={`secondary-button ${props.highContrast ? "active" : ""}`} onClick={props.onToggleHighContrast}>ניגודיות גבוהה {props.highContrast ? "פעילה" : "כבויה"}</button>
        <button ref={closeRef} className="primary-button" onClick={props.onClose}>סיום</button>
      </section>
    </div>
  );
}
